import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

export default function ShippingPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${t('shippingH1')} | CSSBuy Spreadsheet`;
  }, [t]);

  const factors = [
    { title: t('shippingFactorWeight'), desc: 'O peso do pacote é um dos principais fatores que influenciam o custo de envio. Quanto mais pesado, maior o custo.' },
    { title: t('shippingFactorDimensions'), desc: 'Dimensões volumétricas também afetam o preço. Pacotes grandes podem ter custos mais elevados.' },
    { title: t('shippingFactorDestination'), desc: 'O destino final do envio influencia diretamente no custo. Países distantes geralmente têm custos mais altos.' },
    { title: t('shippingFactorMethod'), desc: 'Diferentes métodos de envio têm diferentes custos e prazos. Escolha o que melhor se adapta às suas necessidades.' },
    { title: t('shippingFactorInsurance'), desc: 'Seguro opcional pode adicionar um custo extra, mas oferece proteção adicional para seu envio.' },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <div className="max-w-6xl mx-auto px-4 md:px-6 pt-24 pb-4">
          <nav className="flex items-center gap-2 text-sm text-foreground-500">
            <Link to="/" className="hover:text-primary-600 transition-colors">{t('breadcrumbHome')}</Link>
            <i className="ri-arrow-right-s-line" style={{ width: 16, height: 16 }} />
            <span className="text-foreground-700">{t('breadcrumbShipping')}</span>
          </nav>
        </div>

        <section className="py-8 md:py-12">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <h1 className="font-heading text-3xl md:text-5xl text-foreground-950 mb-6">
              {t('shippingH1')}
            </h1>
            <p className="text-lg text-foreground-700 leading-relaxed mb-10 max-w-3xl">
              {t('shippingIntro')}
            </p>

            <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-6">
              Fatores que Influenciam o Custo
            </h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-10">
              {factors.map((factor, index) => (
                <div key={index} className="bg-background-100 rounded-xl p-5">
                  <h3 className="font-semibold text-foreground-950 mb-2 text-sm">{factor.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{factor.desc}</p>
                </div>
              ))}
            </div>

            <div className="bg-primary-50 rounded-2xl p-6 md:p-8 mb-10">
              <p className="text-sm text-foreground-700 flex items-start gap-2">
                <i className="ri-information-line text-primary-500 mt-0.5 flex-shrink-0" style={{ width: 16, height: 16 }} />
                <span>{t('infoDisclaimer')}</span>
              </p>
            </div>

            <div className="mt-10 pt-8 border-t border-background-200/70">
              <h3 className="font-semibold text-foreground-950 mb-4">{t('articleRelated')}</h3>
              <div className="flex flex-wrap gap-3">
                <Link to="/cssbuy-spreadsheet" className="px-4 py-2 bg-background-100 rounded-lg text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors">{t('breadcrumbSpreadsheet')}</Link>
                <Link to="/cssbuy-review" className="px-4 py-2 bg-background-100 rounded-lg text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors">{t('navReview')}</Link>
                <Link to="/cssbuy-guide" className="px-4 py-2 bg-background-100 rounded-lg text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors">{t('navGuide')}</Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}